import { render, staticRenderFns } from "./BankingInfo.vue?vue&type=template&id=db226328"
import script from "./BankingInfo.vue?vue&type=script&lang=js"
export * from "./BankingInfo.vue?vue&type=script&lang=js"
import style0 from "./BankingInfo.vue?vue&type=style&index=0&id=db226328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports